import styled from "styled-components";

export const Container = styled.main``;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-size: 14px;

    overflow-y: scroll;
    height: 470px;
    width: 100%;

    &::-webkit-scrollbar {
        width: 5px;
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
    &::-webkit-scrollbar-thumb{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
        border-radius: 20px;
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 30px;
    width: 100%;
`;

export const ContentImage = styled.div`
    display: flex;
    justify-content: center;
    width: 100px;

    border-radius: 4px;
    background-color: ${(props) => props.theme.colors.white};
    box-shadow: 1px 0px 5px 0px  ${(props) => props.theme.colors.gray.gray_100};
    padding: 0px 4px;

    @media (max-width: 900px){
        display: none;
    }
`;

export const Image = styled.img`
    width: 100px;
`;

export const ContentInfor = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const Infor = styled.p`
    display: flex;
    gap: 5px;
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-weight: 500;
    
    span{
        color: ${(props) => props.theme.colors.gray.gray_500};
        font-weight: 500;
    }
`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const Section = styled.div`
    display: flex;
    justify-content: space-between;

    @media (max-width: 900px) {
        flex-direction: column;
        gap: 5px;
    }
`;

export const FeaturedSection = styled.div`
    display: flex;
    justify-content: space-between;

    padding: 10px;
    border-radius: 4px;
    background-color: ${(props) => props.theme.colors.gray.gray_50};
`;

export const ContentBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const InforBody = styled.p`
    display: flex;
    flex-direction: column;
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-weight: 500;
    
    span{
        color: ${(props) => props.theme.colors.gray.gray_500};
    }
`;

export const Description = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_500};
    text-align: justify;
`;

export const ContentButton = styled.div`
    display: flex;
    justify-content: end;
`;

//Table
export const ContainerTable = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${(props) => props.theme.colors.white};
    box-shadow: 2px 2px 8px 0px ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 8px;
    padding: 3px 5px;
    max-height: 350px;
    width: 100%;
    
    overflow-x: auto;
    
    @media (max-width: 900px) {
        width: 350px;
        white-space: nowrap;
    }
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

export const Thead = styled.thead`
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    top: 0;
    z-index: 1;

    th{
        font-weight: 500;
        font-size: 14px;

        border: 1px solid ${(props) => props.theme.colors.gray.gray_50};
        text-align: center;
        padding: 10px 0;
    }
`;

export const Tbody = styled.tbody`
`;

export const Td = styled.td`
    border: 1px solid ${(props) => props.theme.colors.gray.gray_50};
    text-align: center;
    padding: 10px 0;
    font-size: 12px;
`;

export const Tr = styled.tr`
`;

export const InforSmall = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_500};
    font-size: 12px;
`;